import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04b49a48"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-6 my-4 plan-selection" }
const _hoisted_3 = { class: "mx-4" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
    /*#__PURE__*/_createElementVNode("b", null, "Plan Selection")
  ])
], -1))
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = {
  class: "btn-group btn-group-toggle",
  "data-toggle": "buttons"
}
const _hoisted_8 = ["disabled"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "OTC Pro Monthly", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode("/month ")
const _hoisted_12 = ["disabled"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "OTC Pro Annual", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/_createTextVNode("/year ")
const _hoisted_16 = { class: "mt-4" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col mt-4" }
const _hoisted_19 = { class: "col-6 my-4" }
const _hoisted_20 = { class: "mx-4" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
    /*#__PURE__*/_createElementVNode("b", null, "Plan Details")
  ])
], -1))
const _hoisted_22 = { class: "row mt-4" }
const _hoisted_23 = { class: "col" }
const _hoisted_24 = { class: "row mt-4" }
const _hoisted_25 = { class: "col" }
const _hoisted_26 = { class: "row mt-4" }
const _hoisted_27 = { class: "col" }
const _hoisted_28 = ["disabled"]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
    /*#__PURE__*/_createElementVNode("div", null, " By submitting this form you confirm that you agress to our Terms of Service and consent to the storing and processing of your personal data as described in our Privacy Policy. ")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading_modal = _resolveComponent("loading-modal")!
  const _component_billing_info_change = _resolveComponent("billing-info-change")!
  const _component_plans_features = _resolveComponent("plans-features")!
  const _component_coupon_form = _resolveComponent("coupon-form")!
  const _component_plan_cost = _resolveComponent("plan-cost")!
  const _component_status_block = _resolveComponent("status-block")!
  const _component_collapsable_container = _resolveComponent("collapsable-container")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_loading_modal, { enabled: _ctx.loadingShow }, null, 8, ["enabled"]),
    _createVNode(_component_collapsable_container, { show: _ctx.show }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("label", {
                      class: _normalizeClass(["btn btn-secondary btn-plan", { active: _ctx.planSelected.code === 'otcpro' }])
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        name: "plan-radios",
                        autocomplete: "off",
                        value: "otcpro",
                        disabled: _ctx.formDisabled,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.planSelected.code) = $event))
                      }, null, 8, _hoisted_8), [
                        [_vModelRadio, _ctx.planSelected.code]
                      ]),
                      _hoisted_9,
                      _hoisted_10,
                      _createElementVNode("b", null, "$" + _toDisplayString(_ctx.formatPrice("otcpro")), 1),
                      _hoisted_11
                    ], 2),
                    _createElementVNode("label", {
                      class: _normalizeClass(["btn btn-secondary btn-plan", { active: _ctx.planSelected.code === 'otcpro_annual' }])
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        name: "plan-radios",
                        autocomplete: "off",
                        value: "otcpro_annual",
                        disabled: _ctx.formDisabled,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.planSelected.code) = $event))
                      }, null, 8, _hoisted_12), [
                        [_vModelRadio, _ctx.planSelected.code]
                      ]),
                      _hoisted_13,
                      _hoisted_14,
                      _createElementVNode("b", null, "$" + _toDisplayString(_ctx.formatPrice("otcpro_annual")), 1),
                      _hoisted_15
                    ], 2)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_billing_info_change, {
                      onBillingInfoUpdated: _ctx.disableBillingInfoEdit,
                      changeEnabled: _ctx.billingInfoEditEnabled,
                      "onUpdate:changeEnabled": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.billingInfoEditEnabled) = $event)),
                      changeCancelEnabled: true
                    }, null, 8, ["onBillingInfoUpdated", "changeEnabled"])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createVNode(_component_plans_features, {
                plan: _ctx.planSelected,
                formDisabled: _ctx.formDisabled
              }, null, 8, ["plan", "formDisabled"]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_component_coupon_form, {
                    formDisabled: _ctx.formDisabled,
                    plan: _ctx.planSelected,
                    onDiscountApplied: _ctx.couponApplied
                  }, null, 8, ["formDisabled", "plan", "onDiscountApplied"])
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_plan_cost, {
                    plan: _ctx.planSelected,
                    coupon: _ctx.coupon
                  }, null, 8, ["plan", "coupon"])
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("button", {
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.activateSubscription && _ctx.activateSubscription(...args))),
                    class: "btn-submit w-100",
                    disabled: _ctx.formDisabled
                  }, "Get Started", 8, _hoisted_28),
                  _createVNode(_component_status_block, {
                    message: _ctx.errorMessage,
                    class: "mt-3"
                  }, null, 8, ["message"])
                ])
              ]),
              _hoisted_29
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}